<template>
  <div id="HdProvisionalMember">
    <popup ref="popup" type="center" :coverClose="false">
      <div class="shortTerm">
        <div class="closeOrOpen">
          <img @click="close()" alt="" src="./img/vip_plan/close.png"/>
        </div>
        <div class="closeTitle">
          <div class="bigTitle">恭喜您，成功升级为 <span>永久会员</span></div>
          <div class="smallTitle">欢迎您加入{{ site_name }}大家庭,感谢您的大力支持</div>
        </div>
        <div class="closeCenter">
          <div>
            <div class="sendCoupons">
              <div>会员有效至： <span>{{ endDate }}（100年）</span></div>
            </div>
          </div>
        </div>
      </div>
    </popup>
  </div>
</template>

<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"

export default {
  components: {popup},
  props: [],
  data() {
    return {
      num: 1,
      timer: null,
      tipMsgDate: "",
      endDate: "",
      site_name: "",
    }
  },
  created() {
    this.site_name = SITE_NAME

    const now = new Date();
    const year = now.getFullYear(); // 获取当前年份
    const month = now.getMonth() + 1; // 获取当前月份，注意getMonth()返回的是0-11，所以需要加1
    const day = now.getDate(); // 获取当前日期
    this.tipMsgDate = year + '-' + month + '-' + day;
    this.endDate = (year + 100) + '-' + month + '-' + day;
  },
  beforeDestroy() {
  },
  methods: {
    show() {
      this.$refs.popup.show();
    },
    close() {
      this.$refs.popup.close();
      location.href = "/"
    },
  },
};
</script>
<style scoped lang="scss">
.shortTerm {
  padding: 0 30px;
  width: 850px;
  height: 570px;
  position: relative;
  background-image: url("./img/vip_plan/011.png");
  background-size: 100% 100%;
  border-radius: 13px;
  overflow: hidden;

  .closeOrOpen {
    display: flex;
    justify-content: flex-end;
    padding: 10px 0 0 0;
    position: absolute;
    top: -3px;
    right: 10px;

    img {
      height: 25px;
      cursor: pointer;
    }
  }

  .closeTitle {
    padding-bottom: 20px;
    margin-top: 35px;

    .bigTitle {
      font-size: 30px;
      font-weight: 700;
      color: #4a3304;
      margin-bottom: 15px;

      span {
        color: #f64834;
      }
    }

    .smallTitle {
      font-size: 16px;
      color: #fc631e;
      //margin-bottom: 20px;
    }
  }

  .closeCenter {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    // 优惠券等待
    .sendCoupons {
      width: 100%;
      height: 450px;
      //background-color: aquamarine;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #000000;

      span {
        color: #cb3131;
      }
    }


  }
}
</style>